import { render, staticRenderFns } from "./ApiAction.vue?vue&type=template&id=532f9a7b&scoped=true&"
import script from "./ApiAction.vue?vue&type=script&lang=js&"
export * from "./ApiAction.vue?vue&type=script&lang=js&"
import style0 from "./ApiAction.vue?vue&type=style&index=0&id=532f9a7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532f9a7b",
  null
  
)

export default component.exports